<template>
  <v-app class="app-dashboard">
    <v-container fluid class="pa-6">
      <!-- KPI Cards -->
      <v-row dense class="mb-4">
        <!-- Meta Total -->
        <v-col cols="12" sm="6" md="3" class="kpi-col-5">
          <v-card class="kpi-card pa-5" outlined>
            <v-skeleton-loader
              v-if="loading"
              type="list-item-avatar-two-line"
            ></v-skeleton-loader>
            <div v-else class="d-flex justify-space-between align-center">
              <div>
                <p class="mb-1 text-uppercase caption grey--text">
                  Meta Total
                </p>
                <div class="display-1 font-weight-bold">
                  {{ cards.total_meta }}
                </div>
              </div>
              <v-avatar color="primary" size="56">
                <v-icon color="white">mdi-flag-checkered</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <!-- Meta Efetivada -->
        <v-col cols="12" sm="6" md="3" class="kpi-col-5">
          <v-card class="kpi-card pa-5" outlined>
            <v-skeleton-loader
              v-if="loading"
              type="list-item-avatar-two-line"
            ></v-skeleton-loader>
            <div v-else class="d-flex justify-space-between align-center">
              <div>
                <p class="mb-1 text-uppercase caption grey--text">
                  Meta Efetivada
                </p>
                <div class="display-1 font-weight-bold success--text">
                  {{ cards.total_cadastro }}
                </div>
              </div>
              <v-avatar color="success" size="56">
                <v-icon color="white">mdi-check-decagram</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <!-- % Realizado -->
        <v-col cols="12" sm="6" md="3" class="kpi-col-5">
          <v-card class="kpi-card pa-5" outlined>
            <v-skeleton-loader
              v-if="loading"
              type="list-item-two-line"
            ></v-skeleton-loader>
            <template v-else>
              <div class="d-flex justify-space-between align-center mb-3">
                <div>
                  <p class="mb-1 text-uppercase caption grey--text">
                    % Realizado
                  </p>
                  <div class="headline font-weight-bold">
                    {{ cards.total_percentual }}%
                  </div>
                </div>
                <v-icon color="primary" large>mdi-chart-arc</v-icon>
              </div>
              <v-progress-linear
                rounded
                height="10"
                color="primary"
                :value="cards.total_percentual"
              ></v-progress-linear>
            </template>
          </v-card>
        </v-col>

        <!-- Cad. Quebrados -->
        <v-col cols="12" sm="6" md="3" class="kpi-col-5">
          <v-card
            class="kpi-card kpi-card--clickable pa-5"
            outlined
            @click="getReportQuebrados(select_equipe)"
          >
            <v-skeleton-loader
              v-if="loading"
              type="list-item-avatar-two-line"
            ></v-skeleton-loader>
            <div v-else class="d-flex justify-space-between align-center">
              <div>
                <p class="mb-1 text-uppercase caption grey--text">
                  Cad. Quebrados
                </p>
                <div class="display-1 font-weight-bold error--text">
                  {{ cards.total_quebra }}
                </div>
              </div>
              <v-avatar color="error" size="56">
                <v-icon color="white">mdi-alert-circle</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <!-- Análise Detalhada -->
        <v-col cols="12" sm="6" md="3" class="kpi-col-5">
          <v-card
            class="kpi-card kpi-card--clickable pa-5"
            outlined
            @click="$router.push({ name: 'dashboard_equipe' })"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <p class="mb-1 text-uppercase caption grey--text">
                  Análise Detalhada
                </p>
                <div class="subtitle-1 font-weight-bold primary--text">
                  Ver mais análises
                </div>
              </div>
              <v-avatar color="info" size="56">
                <v-icon color="white">mdi-chart-bar</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Tabela de Candidatos -->
      <v-card class="table-card" outlined>
        <v-data-table
          :headers="headers"
          :items="itemsWithIndex"
          :search="search"
          :fixed-header="true"
          :items-per-page="-1"
          height="50vh"
        >
          <template v-slot:top>
            <v-toolbar flat class="px-4">
              <v-toolbar-title class="font-weight-medium">
                Lista de Candidatos
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
                dense
                rounded
                outlined
                class="mr-4"
                style="max-width: 300px"
              ></v-text-field>
              <v-btn
                title="Atualizar os Dados"
                color="primary"
                rounded
                small
                @click="atualizarDados()"
              >
                <v-icon left small>mdi-refresh</v-icon>
                Atualizar
              </v-btn>
            </v-toolbar>
          </template>

          <template v-slot:item.percentual="{ item }">
            <v-chip
              small
              :color="getPercentColor(item.percentual)"
              dark
            >
              {{ item.percentual }}%
            </v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              icon
              small
              color="primary"
              @click="
                detalheAssessor(item.id, item.nome_completo);
                getMetas(item.id);
              "
            >
              <v-icon small>mdi-eye</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>

      <!-- Dialog Apuração -->
      <v-dialog v-model="dialog_apuracao" max-width="500">
        <v-card class="dialog-card pa-2">
          <v-card-title class="headline font-weight-medium">
            Apuração Final
          </v-card-title>

          <v-card-text>
            <v-select
              v-model="selects.apuracao.value"
              class="mt-4"
              :items="selects.apuracao.items"
              outlined
              rounded
              dense
              label="Tipo de Apuração"
              item-value="id"
              item-text="descricao"
            ></v-select>
            <v-select
              v-if="selects.apuracao.value > 2"
              v-model="selects.candidatos_metas.value"
              :items="selects.candidatos_metas.items"
              outlined
              rounded
              dense
              label="Equipe"
              item-value="idcandidato"
              item-text="nome_completo"
              multiple
            ></v-select>
            <v-select
              v-if="selects.apuracao.value < 3"
              v-model="select_meta"
              :items="selects.metas.items"
              outlined
              rounded
              dense
              label="Tipo de Meta"
              item-value="idmeta"
              item-text="descricao"
            ></v-select>
            <v-select
              v-if="selects.apuracao.value > 2"
              v-model="select_meta_cruzada"
              :items="selects.metas_cruzadas.items"
              outlined
              rounded
              dense
              label="Metas"
              item-value="idmeta"
              item-text="descricao"
            ></v-select>
            <v-select
              v-if="selects.apuracao.value > 2"
              v-model="selects.tipo_ordenacao.value"
              :items="selects.tipo_ordenacao.items"
              outlined
              rounded
              dense
              label="Tipo Ordenação"
              item-value="id"
              item-text="descricao"
            ></v-select>
            <v-text-field
              v-if="selects.apuracao.value > 2 && selects.tipo_ordenacao.value == 4"
              v-model.number="min_extra"
              type="number"
              min="1"
              outlined
              rounded
              dense
              label="Mínimo de cadastros extras"
              hint="Só entra quem cadastrou pelo menos esse número além da meta"
              persistent-hint
              class="mb-3"
            ></v-text-field>

            <v-btn
              v-if="selects.apuracao.value < 3"
              block
              rounded
              color="primary"
              class="mb-3"
              @click="getReportApuracaoAssessor(id_assessor)"
            >
              Apuração por Assessor
            </v-btn>
            <v-btn
              v-if="selects.apuracao.value < 3"
              block
              rounded
              color="primary"
              outlined
              class="mb-3"
              @click="getReportApuracaoMeta(id_assessor)"
            >
              Apuração por Metas
            </v-btn>
            <v-btn
              v-if="selects.apuracao.value > 2"
              block
              rounded
              color="primary"
              @click="getReportApuracaoMetaCruzada(id_assessor)"
            >
              Processar
            </v-btn>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              rounded
              @click="dialog_apuracao = false"
            >
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog Detalhes Assessor (fullscreen) -->
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="#0E314A">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Listagem dos Assessores</v-toolbar-title>
          </v-toolbar>

          <v-container fluid class="pa-6">
            <v-card class="table-card" outlined>
              <v-data-table
                :headers="headers_assessor"
                :items="itemsAssessorWithIndex"
                :fixed-header="true"
                height="70vh"
                :hide-default-footer="false"
                :items-per-page="-1"
                :search="search"
                item-key="index"
              >
                <template v-slot:top>
                  <v-toolbar flat class="px-4">
                    <span class="subtitle-1 font-weight-medium">
                      EQUIPE: {{ assessor }}
                    </span>
                    <v-spacer></v-spacer>
                    <v-text-field
                      :value="search"
                      @input="onSearchInput"
                      append-icon="mdi-magnify"
                      label="Pesquisar"
                      single-line
                      hide-details
                      dense
                      rounded
                      outlined
                      clearable
                      style="max-width: 400px"
                    ></v-text-field>
                    <v-btn
                      color="warning"
                      small
                      rounded
                      title="Apuração Final"
                      class="ml-4"
                      @click="dialog_apuracao = true"
                    >
                      <v-icon left small>mdi-tray-full</v-icon>
                      Apuração
                    </v-btn>
                  </v-toolbar>
                </template>

                <template v-slot:item.percentual="{ item }">
                  <v-chip
                    small
                    :color="getPercentColor(item.percentual)"
                    dark
                  >
                    {{ item.percentual }}%
                  </v-chip>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-btn
                    icon
                    small
                    color="primary"
                    @click="getReportAssessor(item.id, item.idcandidato)"
                  >
                    <v-icon small>mdi-printer</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-app>
</template>

<script>
import DashboardAPI from "./../../api/dashboard";
import AclAPI from "./../../api/acl";

export default {
  data() {
    return {
      loading: true,
      dialog: false,
      dialog_apuracao: false,
      search: "",
      searchTimer: null,
      assessor: "",
      id_assessor: 0,
      cards: {
        total_meta: 0,
        total_cadastro: 0,
        total_percentual: 0,
        total_quebra: 0,
      },
      select_equipe: 0,
      select_meta: 0,
      select_meta_cruzada: 0,
      min_extra: 30,
      selects: {
        candidatos: {
          ativado: false,
          value: 0,
          items: [],
        },
        candidatos_metas: {
          value: [],
          items: [],
        },
        metas: {
          value: 0,
          items: [],
        },
        metas_cruzadas: {
          value: 0,
          items: [],
        },
        apuracao: {
          value: 1,
          items: [
            {
              id: 1,
              descricao: "CRUZAMENTO GERAL",
            },
            {
              id: 2,
              descricao: "CRUZAMENTO META",
            },
            {
              id: 3,
              descricao: "CRUZAMENTO ENTRE EQUIPES",
            },
          ],
        },
        tipo_ordenacao: {
          value: 0,
          items: [
            {
              id: 0,
              descricao: "PONTUACAO GERAL",
            },
            {
              id: 1,
              descricao: "PONTUACAO META",
            },
            {
              id: 2,
              descricao: "PONTUACAO FINAL",
            },
            {
              id: 3,
              descricao: "PONTUACAO EXTRA",
            },
            {
              id: 4,
              descricao: "QUALIDADE DO EXTRA",
            },
          ],
        },
      },
      headers: [
        { text: "Índice", value: "index" },
        {
          text: "Equipe",
          align: "start",
          value: "equipe",
        },
        {
          text: "Nome Completo",
          align: "start",
          value: "nome_completo",
        },
        { text: "Meta", value: "total_geral_meta" },
        { text: "Total de Cadastrados", value: "total_cadastrado" },
        { text: "Percentual Meta", value: "percentual" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      desserts: [],
      headers_assessor: [
        { text: "Índice", value: "index" },
        {
          text: "Equipe",
          align: "start",
          value: "equipe",
        },
        {
          text: "Nome Completo",
          align: "start",
          value: "nome_completo",
        },
        { text: "Meta", value: "total_geral_meta" },
        { text: "Total de Cadastrados", value: "total_cadastrado" },
        { text: "Percentual Meta", value: "percentual" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      desserts_assessor: [],
    };
  },
  computed: {
    setarEquipe() {
      const equipe = localStorage.getItem("equipe");
      return equipe;
    },
    itemsWithIndex() {
      return this.desserts.map((items, index) => ({
        ...items,
        index: index + 1,
      }));
    },
    itemsAssessorWithIndex() {
      return this.desserts_assessor.map((items, index) => ({
        ...items,
        index: index + 1,
      }));
    },
  },
  watch: {
    buscaCandidatos() {
      this.select_equipe = this.setarEquipe;
    },
  },

  created() {
    this.Helpers.verificarToken();
    this.buscaCandidatos();
    setTimeout(() => {
      this.setEquipe();
    }, 200);
    setTimeout(() => {
      this.buscarCandidatos();
      this.buscarTotais();
    }, 300);
  },
  methods: {
    onSearchInput(val) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.search = val || "";
      }, 500);
    },
    getPercentColor(percentual) {
      const val = parseFloat(percentual) || 0;
      if (val >= 100) return "success";
      if (val >= 50) return "warning";
      return "error";
    },

    buscaCandidatos() {
      const headers = this.Helpers.iniciarRequisicao();
      AclAPI.getCandidatos(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.candidatos.items = [];
          this.selects.candidatos_metas.items = [];

          if (response.status == 200) {
            this.selects.candidatos.items = response.data.candidatos;
            this.selects.candidatos_metas.items = response.data.candidatos;

            let objCandidato = {
              idcandidato: "null",
              nome_completo: "TODAS",
              chapa: 0,
            };

            this.selects.candidatos.items.push(objCandidato);
            this.selects.candidatos_metas.items.push(objCandidato);
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    buscarTotais() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        equipe: this.select_equipe,
      };

      DashboardAPI.getTotais(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.cards.total_meta = response.data.totais[0].total_geral_meta;
          this.cards.total_cadastro = response.data.totais[0].total_cadastrado;
          this.cards.total_percentual = response.data.totais[0].percentual;
          this.cards.total_quebra = response.data.quebra[0].total;
          this.loading = false;
        })
        .catch(() => {
          this.$store.dispatch("loading/habilitarLoading", false);
          this.loading = false;
          this.Helpers.logout();
        });
    },
    buscarCandidatos() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        equipe: this.select_equipe,
        meta: this.select_meta,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DashboardAPI.getCandidatos(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.desserts = response.data.candidatos;
          })
          .catch(() => {
            this.$store.dispatch("loading/habilitarLoading", false);
            this.Helpers.logout();
          })
      );
    },

    buscarAssessores(id) {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        equipe: id,
        meta: this.select_meta,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DashboardAPI.getAssessores(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.desserts_assessor = response.data.assessores;
          })
          .catch(() => {
            this.$store.dispatch("loading/habilitarLoading", false);
            this.Helpers.logout();
          })
      );
    },

    detalheAssessor(id, assessor) {
      this.dialog = true;
      this.assessor = assessor;
      this.id_assessor = id;
      this.buscarAssessores(id);
    },

    getMetas(equipe) {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        equipe: equipe,
      };

      AclAPI.getMetas(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.metas.items = [];

          if (response.status == 200) {
            this.selects.metas.items = response.data.metas;

            let objMetas = {
              idmeta: "null",
              descricao: "TODAS",
            };

            this.selects.metas.items.push(objMetas);
            this.select_meta = "null";

            this.getMetasCruzada();
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },

    getMetasCruzada() {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {};

      AclAPI.getMetasCruzada(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.metas_cruzadas.items = [];

          let objMetas = {
            idmeta: "null",
            descricao: "TODAS",
          };

          if (response.status == 200) {
            this.selects.metas_cruzadas.items = response.data.metas;
            this.selects.metas_cruzadas.items.push(objMetas);
            this.select_meta_cruzada = 5;
            this.selects.metas_cruzadas.value = 5;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },

    getReportAssessor(id, idcandidato) {
      const id_cd = localStorage.getItem("id");
      // Equipe DA LINHA (cada linha = vínculo assessor x equipe); fallback no filtro global.
      const equipeParam =
        idcandidato && idcandidato !== "null"
          ? idcandidato
          : this.select_equipe && this.select_equipe !== "null"
          ? this.select_equipe
          : 0;
      let url =
        "relatorio_assessores?id=" +
        id +
        "&id_cd=" +
        id_cd +
        "&equipe=" +
        equipeParam;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },
    getReportQuebrados(id) {
      let url = "relatorio_quebrados?id=" + id;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },
    getReportApuracaoAssessor(id) {
      let url =
        "relatorio_apuracao?equipe=" +
        id +
        "&meta=" +
        this.select_meta +
        "&tipo=" +
        2 +
        "&tipo_apuracao=" +
        this.selects.apuracao.value;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },
    getReportApuracaoMeta(id) {
      let url =
        "relatorio_apuracao?equipe=" +
        id +
        "&meta=" +
        this.select_meta +
        "&tipo=" +
        1 +
        "&tipo_apuracao=" +
        this.selects.apuracao.value;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },

    getReportApuracaoMetaCruzada(id) {
      let url =
        "relatorio_apuracao_cruzado?equipe=" +
        this.selects.candidatos_metas.value +
        "&meta=" +
        this.select_meta_cruzada +
        "&tipo=" +
        1 +
        "&ordem=" +
        this.selects.tipo_ordenacao.value +
        "&min_extra=" +
        this.min_extra;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },

    setEquipe() {
      const equipe = localStorage.getItem("equipe");

      if (equipe != "null") {
        this.select_equipe = parseInt(equipe);
        this.selects.candidatos.ativado = true;
        this.getMetas(equipe);
      } else {
        this.select_equipe = "null";
        this.getMetas("null");
      }
    },
    atualizarDados() {
      this.loading = true;
      this.buscarCandidatos();
      this.buscarTotais();
    },
  },
};
</script>

<style scoped>
.app-dashboard {
  background-color: #f4f5f7;
  min-height: 100vh;
}

.kpi-card {
  border-radius: 16px;
  min-height: 130px;
  transition: box-shadow 0.2s;
}

.kpi-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.kpi-card--clickable {
  cursor: pointer;
}

.table-card {
  border-radius: 16px;
  overflow: hidden;
}

.dialog-card {
  border-radius: 16px;
}

@media (min-width: 960px) {
  .kpi-col-5 {
    flex: 0 0 20%;
    max-width: 20%;
  }
}
</style>
